import React from 'react';
import { goToPage } from '../../utils/links';
import CityCard, { CityCardProps } from '../city-card/CityCard';
import * as styles from './CityList.style';

export interface CityListProps {
  columns?: number,
  cities: CityCardProps[],
}

const CityList: React.FC<CityListProps> = ({
  columns = 4,
  cities,
}) => {
  const onClick = React.useCallback((city: CityCardProps) => () => {
    goToPage(city.urlObject);
  }, []);

  return (
    <ul css={styles.list}>
      {cities.map((city) => (
        <li
          key={city.name}
          css={styles.item}
          $columns={Math.max(1, columns)}
        >
          <CityCard
            name={city.name}
            picture={city.picture}
            onClick={city.urlObject ? onClick(city) : undefined}
            averageSellPrice={city.averageSellPrice}
            overriddenAlt={city.overriddenAlt}
            urlObject={city.urlObject}
          />
        </li>
      ))}
    </ul>
  );
};

export default CityList;
